import { getLocale } from '../../../utils/pathHelper';
import { formatCheckinCheckoutDates, formatRooms, fixRoomsParam } from '../../helper/accommodation_helper';

type Props = {
  host: string,
}

export default class AccommodationApiClient {
  host: string

  constructor(props: Props) {
    this.host = props.host;
  }

  get headers() {
    return {
      'X-CLIENT-TYPE': 'web',
      'X-DEVICE-OS': 'web',
      'Accept-Language': getLocale({ underscore: false }),
    };
  }

  get baseUri() {
    return `${this.host}/api/v1`;
  }

  get yadosUri() {
    return `${this.baseUri}/yados`;
  }

  fetchYadoListPrices(searchParams, yadoIds: Array<string>, onCompletedFn: (data: any, yadoIds: Array<string>) => void) {
    const $ = (window as any).jQuery;
  
    const dates = formatCheckinCheckoutDates(searchParams);
    const rooms = formatRooms(searchParams);
    const url = this.yadosUri + buildFetchYadoListPricesParam(dates, rooms, yadoIds, 50, 1);
    $.ajax({
      type: 'GET',
      url,
      headers: this.headers,
    })
    .done((data) => {
      onCompletedFn(data, yadoIds);
    });
  }
  
  fetchYadoPlanItems(searchParams, yadoId: string, onCompletedFn: (data: any) => void, onFailedFn: (status: number, responseJSON: Object) => void) {
    const $ = (window as any).jQuery;
  
    const dates = formatCheckinCheckoutDates(searchParams);
    const rooms = formatRooms(searchParams);
    const url = `${this.yadosUri}/${yadoId}/plans${buildFetchYadoPlanParam(dates, rooms)}`;
    $.ajax({
      type: 'GET',
      url,
      headers: this.headers,
    })
    .done((data) => {
      onCompletedFn(data);
    }).fail((jqXHR) => {
      onFailedFn(jqXHR.status, jqXHR.responseJSON);
    });
  }

  fetchYadoPlanDetail(searchParams, yadoId: string, planId: string, onCompletedFn: (data: any) => void, onFailedFn: (status: number, responseJSON: Object) => void) {
    const $ = (window as any).jQuery;
  
    const dates = formatCheckinCheckoutDates(searchParams);
    const rooms = formatRooms(searchParams);
    const url = `${this.yadosUri}/${yadoId}/plans/${planId}${buildFetchYadoPlanParam(dates, rooms)}`;
    $.ajax({
      type: 'GET',
      url,
      headers: this.headers,
    })
    .done((data) => {
      onCompletedFn(data);
    }).fail((jqXHR) => {
      onFailedFn(jqXHR.status, jqXHR.responseJSON);
    });
  }
}
  
function buildFetchYadoListPricesParam(dates, rooms, yadoIds, limit, page) {
  const $ = (window as any).jQuery;

  let param = `?${$.param({
    checkin_date: dates.checkinDate,
    checkout_date: dates.checkoutDate,
    rooms: rooms,
    yado_ids: yadoIds,
  })}`;
  param = fixRoomsParam(param);

  return param;
}
 
function buildFetchYadoPlanParam(dates, rooms) {
  const $ = (window as any).jQuery;

  let param = `?${$.param({
    checkin_date: dates.checkinDate,
    checkout_date: dates.checkoutDate,
    rooms: rooms,
  })}`;
  param = fixRoomsParam(param);

  return param;
}
